<template>
  <div class="mx-auto my-5">
    <b-modal ref="modalExist" title="Attention:">
      <div class="d-block text-center">
        <p>用户{{email}}已经存在</p>
      </div>
      <div slot="modal-footer">
        <b-button variant="primary" class="mr-3" to="/login">这里登录</b-button>
        <b-button @click="resendEmail">重新发送确认邮件</b-button>
      </div>
    </b-modal>
    <div class="account-wall mb-3">
      <h1 class="text-center login-title">注册</h1>
      <b-form class="form-login" ref="ruleForm">
        <b-form-input v-model="email" type="email" v-validate="'required|email'" 
          :class="{'form-control':true, 'is-invalid':errors.has('email'), 'mb-3':true}" name="email" placeholder="邮箱 (*)">
        </b-form-input>
        <b-form-input v-model="first" type="text" placeholder="你的名字"
          name="first" 
          :class="{'form-control':true, 'is-invalid':errors.has('first'), 'mb-3':true}">
        </b-form-input>
        <b-form-input v-model="last" type="text" placeholder="你的姓氏"
          name="last" 
          :class="{'form-control':true, 'is-invalid':errors.has('last'), 'mb-3':true}">
        </b-form-input>
        <b-form-input v-model="institution" type="text" placeholder="所属机构"
          name="institution" 
          :class="{'form-control':true, 'is-invalid':errors.has('institution'), 'mb-3':true}">
        </b-form-input>
        <b-form-input v-model="password" type="password" placeholder="密码 (*)"
          name="password" v-validate="'required|alpha_dash|min:6'" 
          :class="{'form-control':true, 'is-invalid':errors.has('password'), 'mb-3':true}">
        </b-form-input>
        <b-form-input v-model="password1" type="password" placeholder="确认密码 (*)"
          name="password_confirmation" v-validate="'required|confirmed:password'"
          data-vv-as="password"
          :class="{'form-control':true, 'is-invalid':errors.has('password_confirmation'), 'mb-4':true}">
        </b-form-input>
        <b-button size="lg" variant="primary" type="submit" @click.prevent="register" block>
            注册</b-button>
      </b-form>
    </div>
    <b-alert v-show="errors.has('email')" show variant="warning">{{ errors.first('email') }}</b-alert>
    <b-alert v-show="errors.has('institution')" show variant="warning">{{ errors.first('institution') }}</b-alert>
    <b-alert v-show="errors.has('first')" show variant="warning">{{ errors.first('first') }}</b-alert>
    <b-alert v-show="errors.has('last')" show variant="warning">{{ errors.first('last') }}</b-alert>
    <b-alert v-show="errors.has('password')" show variant="warning">{{ errors.first('password') }}</b-alert>
    <b-alert v-show="errors.has('password_confirmation')" show variant="warning">{{ errors.first('password_confirmation') }}</b-alert>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      first: '',
      last: '',
      institution: '',
      password: '',
      password1: '',
      checked: false,
      logining: false,
      rememberMe: false,
      fetchUser: false
    }
  },

  methods: {
    register () {
      this.$validator.validateAll()
      .then(result => {
        if (!result) {
          return
        }
        this.$auth.register({
          data: {
            email: this.email,
            password: this.password,
            firstName: this.first,
            lastName: this.last,
            institution: this.institution
          },
          rememberMe: this.rememberMe,
          redirect: 'login',
          fetchUser: this.fetchUser
        })
        .then((res) => {
          // FIXME: ElementUI is required to use $message, need to find a replacement
          console.log(res.data.message)
          alert(res.data.message)
        })
        .catch((error) => {
          console.log(error)
          if (error.response.data.status === 'alreadyExists') {
            this.$refs.modalExist.show()
          } else {
            console.log(error.response)
            if (error.response.data.message) {
              this.$message(error.response.data.message)
            }
          }
        })
      })
    },

    resendEmail () {
      this.$http.post('/user/send_confirmation_email/' + this.email)
      .then(res => {
        this.$router.push('/login')
        alert(res.data.message)
      })
      .catch((error) => {
        if (error.response.status === 429) {
          this.$message('请求提交过于频繁，请稍后再试。')
        } else {
          console.log(error.response)
          if (error.response.data.message) {
            this.$message(error.response.data.message)
          }
        }
      })
    }
  },

  mounted () {
    console.log(this.$auth.redirect())
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
